import http from "./httpService";

const apiEndpoint = process.env.REACT_APP_API_URL;

export function getCars() {
    return http.get(apiEndpoint + "/cars");
}

export function createCar(data) {
    return http.post(apiEndpoint + '/api/cars', data);
}

export function getAllCars() {
    return http.get(apiEndpoint + "/api/cars");
}

export function getCar(id) {
    return http.get(apiEndpoint + "/api/cars/" + id);
}

export function updateCar(id, data) {
    return http.put(apiEndpoint + "/api/cars/" + id, data);
}

export function deleteCar(id) {
    return http.delete(apiEndpoint + "/api/cars/" + id);
}